import SeoHead from "../components/homepage/SeoHead";
import Navbar from "../components/homepage/Navbar";
import Hero from "../components/homepage/Hero";
import ClientLogos from "../components/homepage/ClientLogos";
import Services from "../components/homepage/Services";
import WhyLumotis from "../components/homepage/WhyLumotis";
import AppCategories from "../components/homepage/AppCategories";
import Process from "../components/homepage/Process";
import Stats from "../components/homepage/Stats";
import CaseStudies from "../components/homepage/CaseStudies";
import Testimonials from "../components/homepage/Testimonials";
import Pricing from "../components/homepage/Pricing";
import BlogSection from "../components/homepage/BlogSection";
import CTABanner from "../components/homepage/CTABanner";
import FAQSection from "../components/homepage/FAQSection";
import Footer from "../components/homepage/Footer";
import GeoBanner from "../components/homepage/GeoBanner";

export default function HomePage() {
  return (
    <>
      <SeoHead />
      <Navbar />
      <main id="main" data-testid="main-content">
        <Hero />
        <ClientLogos />
        <Services />
        <WhyLumotis />
        <AppCategories />
        <Process />
        <Stats />
        <CaseStudies />
        <Testimonials />
        <Pricing />
        <BlogSection />
        <CTABanner />
        <FAQSection />
      </main>
      <Footer />
      <GeoBanner />
    </>
  );
}
